import React, { useState } from "react";

import { useUser } from "../../user/hooks";
import Button, { BUTTON_STYLES } from "../../common/components/Button";
import TextInput from "../../common/components/TextInput";
import TextArea from "../../common/components/TextArea";
import { useToken } from "../../auth/hooks";
import { BASE_URL } from "../../constants";

export const CommentEditor = ({ postId, refresh }) => {
  const token = useToken();
  const user = useUser();

  const [comment, setComment] = useState("");
  const [author, setAuthor] = useState(user.name);

  const publishComment = async () => {
    if (comment && author) {
      const response = await fetch(`${BASE_URL}api/sitrep/comments`, {
        method: "POST",
        body: JSON.stringify({ author, postId, text: comment }),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      refresh();
      setComment("");
    }
  };

  return (
    <div style={{ width: "100%", margin: "1.5rem 0" }}>
      {" "}
      <TextArea
        style={{ boxSizing: "border-box", width: "100%" }}
        value={comment}
        onChange={setComment}
        rows={4}
        label="Comment"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <div>
          <TextInput
            type="text"
            id="name"
            label="Comment By:"
            value={author}
            onChange={setAuthor}
          />
        </div>
        <div>
          <Button
            onClick={publishComment}
            text="Publish Comment"
            style={BUTTON_STYLES.PRIMARY}
          />
        </div>
      </div>
    </div>
  );
};
